import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { COLORS } from '../constants/styles';

export default class CircularLoading extends Component {
    static propTypes = {
        color: PropTypes.string,
        style: PropTypes.object,
        size: PropTypes.oneOf(['small', 'large']),
    };

    static defaultProps = {
        size: 'small',
        color: COLORS.PURPLE_PLUM,
    };

    render() {
        const { color, style, size } = this.props;
        const classNames = ['circular-loading', size];

        return (
            <div style={{ ...style, stroke: color }} className={classNames.join(' ')}>
                <svg version="1.1" x="0px" y="0px" viewBox="0 0 66 66">
                    <circle cx="33" cy="33" r="30" />
                </svg>
            </div>
        );
    }
}
